"use client";

import { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

const AdminHeader = ({
  user,
  notifications,
  onNotificationRead,
  onToggleSidebar,
  searchQuery,
  onSearchChange,
}) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const notificationRef = useRef(null);
  const userMenuRef = useRef(null);

  const unreadCount = notifications.filter((n) => n.unread).length;

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const onLogout = () => {
    window.location.href = '/admin';
    Cookies.remove("isLoggedIn");
    Cookies.remove("Id");
  };
  const getNotificationIcon = (type) => {
    switch (type) {
      case "success":
        return "✅";
      case "warning":
        return "⚠️";
      case "error":
        return "❌";
      default:
        return "ℹ️";
    }
  };

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  useEffect(() => {
    const fetchUserName = async () => {
      const userId = Cookies.get("adminId"); // Make sure this matches your cookie name

      if (!userId) return;

      const data = new FormData(); // ✅ Correct way to declare FormData
      data.append("user_id", userId);

      try {
        const response = await fetch("https://leapatinternational.com/admin/api/v1/user_profile.php", {
          method: "POST",
          body: data, // ✅ FormData sent in POST body
        });

        const result = await response.json();
        if (result.status === "success") {
          setUserName(result.data.username);
          setUserEmail(result.data.email);
        } else {
          console.error("Error:", result.message);
        }
      } catch (error) {
        console.error("Network Error:", error);
      }
    };

    fetchUserName();
  }, []);
  return (
    <header className="dashboard-header">
      <div className="header-content">
        {/* Left Section */}
        <div className="header-left">
          <button className="sidebar-toggle-btn" onClick={onToggleSidebar} aria-label="Toggle sidebar">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>

          {/* <div className="search-container">
            <div className="search-input-group">
              <span className="search-icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </span>
              <input
                type="text"
                className="search-input"
                placeholder="Search dashboard..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          </div> */}
        </div>

        {/* Right Section */}
        <div className="header-right">
          {/* Quick Actions */}
          {/* <div className="quick-actions">
            <button className="quick-action-btn" title="Create New">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z" />
              </svg>
            </button>
            <button className="quick-action-btn" title="Settings">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319z" />
              </svg>
            </button>
          </div> */}

          {/* Notifications */}
          {/* <div className="notification-dropdown" ref={notificationRef}>
            <button
              className="notification-btn"
              onClick={() => setShowNotifications(!showNotifications)}
              aria-label="Notifications"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 2C7.8 2 6 3.8 6 6v4l-2 2v1h12v-1l-2-2V6c0-2.2-1.8-4-4-4zm0 16c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2z" />
              </svg>
              {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
            </button>

            {showNotifications && (
              <div className="notification-panel">
                <div className="notification-header">
                  <h6>Notifications</h6>
                  <span className="notification-count">{unreadCount} unread</span>
                </div>
                <div className="notification-list">
                  {notifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`notification-item ${notification.unread ? "unread" : ""}`}
                      onClick={() => onNotificationRead(notification.id)}
                    >
                      <div className="notification-icon">{getNotificationIcon(notification.type)}</div>
                      <div className="notification-content">
                        <p className="notification-message">{notification.message}</p>
                        <span className="notification-time">{notification.time}</span>
                      </div>
                      {notification.unread && <div className="unread-indicator"></div>}
                    </div>
                  ))}
                </div>
                <div className="notification-footer">
                  <button className="btn btn-sm btn-outline-primary w-100">View All Notifications</button>
                </div>
              </div>
            )}
          </div> */}

          {/* User Menu */}
          <div className="user-dropdown" ref={userMenuRef}>
            <button className="user-menu-btn" onClick={() => setShowUserMenu(!showUserMenu)} aria-label="User menu">
              <img src="/assets/img/profile.jfif" alt={user.name} className="user-avatar" />
              <div className="user-info d-none d-md-block">
                <span className="user-name">{userName}</span>
                <span className="user-role">{user.role}</span>
              </div>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" className="dropdown-arrow">
                <path d="M6 8L2 4h8z" />
              </svg>
            </button>

            {showUserMenu && (
              <div className="user-menu-panel">
                <div className="user-menu-header">
                  <img src="/assets/img/profile.jfif" alt={user.name} className="user-avatar-large" />
                  <div className="user-details">
                    <h6>{userName}</h6>
                    <p>{userEmail}</p>
                  </div>
                </div>
                <div className="user-menu-items">
                  {/* <button className="user-menu-item">
                    <span className="menu-icon">👤</span>
                    <span>Profile Settings</span>
                  </button>
                  <button className="user-menu-item">
                    <span className="menu-icon">🔒</span>
                    <span>Privacy & Security</span>
                  </button>
                  <button className="user-menu-item">
                    <span className="menu-icon">💳</span>
                    <span>Billing & Plans</span>
                  </button>
                  <button className="user-menu-item">
                    <span className="menu-icon">❓</span>
                    <span>Help & Support</span>
                  </button> */}
                  <button className="user-menu-item logout-item" onClick={onLogout}>
                    <span className="menu-icon">🚪</span>
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
